import React, { useContext } from 'react';
import CoopSelectContext from '../CoopSelectContext';
import AgentDetails from './AgentDetails';
import CustomAgentDetails from './CustomAgentDetails';
import NonAgentDetails from './NonAgentDetails';

const InPersonCoopDetails: React.FC = () => {
  const { coop, coopAdditionalData } = useContext(CoopSelectContext);

  if (!coop || !coopAdditionalData) return null;

  if (coopAdditionalData.coopType === 'agent') return <AgentDetails />;
  if (coopAdditionalData.coopType === 'customAgent')
    return <CustomAgentDetails />;
  return <NonAgentDetails />;
};

export default InPersonCoopDetails;
